module.exports = __webpack_public_path__ + "img/api-step-4@2x.2293fc41.png";